export default __webpack_public_path__ + "static/media/neo-fest-activities.01abee37.png";